module.exports = __webpack_public_path__ + "img/tribackground.7a19c387.png";